// Global session manager
let sessionExpiredCallback = null;

export const setSessionExpiredCallback = (callback) => {
  sessionExpiredCallback = callback;
};

export const triggerSessionExpired = () => {
  if (sessionExpiredCallback) {
    sessionExpiredCallback();
  }
};